import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

export const loadOrderParameters = (data: any) => {
  return axios.get('/parameters/order', data)
}

export function useLoadOrderParameters(query: any) {
  return useQuery(
    ['orderParameters', query],
    () => loadOrderParameters(query),
    {
      onError: () =>
        toast.error('Não foi possível carregar os parâmetros do pedido!', {
          toastId: 'loadOrderParameters'
        })
    }
  )
}
